module.exports = __webpack_public_path__ + "img/zhongYao2.c4400185.png";